module.exports = __webpack_public_path__ + "static/media/black-forward-arrow.6a1bb069.svg";